import React, { useEffect } from 'react';
import { Gant } from './components/Gant/Gant';
import { actions, stageSelector } from './store/reducers/stageSlice/stageSlice';
import { useDispatch, useSelector } from 'react-redux';
import { fetchStages } from './store/reducers/stageSlice/actions';
import { Loader } from '../../components/UI/NewLoader/Loader/Loader';
import { EmptyGant } from './components/UI/EmptyGant';
import { positionActions, positionSelector } from './store/reducers/positionSlice/positionSlice';
import { charterActions } from './store/reducers/charterSlice/charterSlice';
import { getNormalizedCharters, getNormalizedStages } from './helpers/getNormalized';
import { stageList } from './helpers/demoMock';
import { gantActions } from './store/reducers/gantSlice/gantSlice';

export function ReactGant() {
    const dispatch = useDispatch();
    const { isLoading } = useSelector((state) => state.gantReducer);
    const isPlanFact = window.estimatePlanFactEnable;

    useEffect(() => {
        const isDemo = $(document).find(`[data-demo]`).attr(`data-demo`);

        if (isDemo === 'true') {
            dispatch(gantActions.changeIsLoading(false));
            const { stages, positions: positionsList } = getNormalizedStages(stageList).entities;

            const allPositionsList = [];
            const allCharterList = [];

            for (const item of Object.values(positionsList)) {
                if (item.is_parent) {
                    allCharterList.push(item);
                } else {
                    allPositionsList.push(item);
                }
            }

            const { charters, children } = getNormalizedCharters(allCharterList).entities;

            const positionsListAll = children
                ? [...allPositionsList, ...Object.values(children)]
                : [...allPositionsList];

            dispatch(actions.addStages(Object.values(stages)));
            if (charters) dispatch(charterActions.addStages(Object.values(charters)));

            dispatch(positionActions.addStages(positionsListAll));
        } else {
            dispatch(fetchStages(''));
        }
    }, []);

    const stages = useSelector(stageSelector.selectAll);
    const positions = useSelector(positionSelector.selectAll);

    let isAllNullPosition = false;

    if (isPlanFact) {
        isAllNullPosition = !positions.some((position) => !!position.actual.start_date);
    }

    return (
        <div id={'gant'}>
            {isLoading ? (
                <Loader />
            ) : (
                <>
                    {!!stages.length && isAllNullPosition === false ? (
                        <Gant stages={stages} />
                    ) : (
                        <EmptyGant isAllNullPosition={isAllNullPosition} />
                    )}
                </>
            )}
        </div>
    );
}
